/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { isEmpty } from 'ramda';
import { useLocation, useSearchParams } from 'react-router-dom';
import { paths } from '../../routes';
import getAppURL from '../../utils/getAppURL';
import getCookie from '../../utils/getCookie';
import getSubdomain from '../../utils/getSubdomain';
import isOnTestServer from '../../utils/isOnTestServer';
import { signOut, useAuth } from '../../context/authContext';

function Support() {
  const [, dispatch] = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const subdomain = getSubdomain(window.location.origin);

  const store =
    searchParams.get('store') ||
    JSON.parse(getCookie('_pos_store') || '{}')?.name ||
    '';

  if (subdomain) {
    // For now any subdomain should be a logged in shop
    const host = window.location.origin.replace(`${subdomain}.`, 'www.');
    window.location.replace(`${host}${location.pathname}?store=${subdomain}`);
  }

  const dashboardPath = React.useMemo(() => {
    const url = new URL(getAppURL());
    const { protocol, host } = url;

    if (!(store && !isEmpty(store))) {
      return '';
    }

    if (isOnTestServer()) {
      return `${protocol}//${host}/${store}/dashboard`;
    }
    return `${protocol}//${store}.${host.replace('www.', '')}/dashboard`;
  }, [store]);

  React.useEffect(() => {
    document.body.style.backgroundColor = '#ffde00';
  }, []);

  return (
    <div className="bg-pos-yellow p-6 tablet:p-10 laptop:p-6 h-screen flex flex-col justify-between">
      <div className="w-full laptop:container mx-auto">
        <header className="w-full">
          <div className="w-full flex items-center justify-between">
            <a
              className="flex items-center text-pos-black font-semibold text-2xl shrink-0"
              href={paths.LANDING_HOME_URL_PATH}
            >
              Swiftinflow
            </a>
            <div className="flex flex-row w-full justify-end content-center space-x-3 items-center">
              <a
                className="hidden tablet:inline-flex items-center justify-center text-pos-hyperlink no-underline
                  text-center h-[40px] w-fit text-base font-normal hover:underline"
                href="tel:+233549961446"
              >
                +233 54 996 1446
              </a>
              {store && dashboardPath ? (
                <>
                  <a
                    className="inline-flex items-center justify-center text-pos-black border-2 border-pos-black rounded-md no-underline
                      hover:bg-pos-black hover:text-pos-yellow text-center h-[40px] w-fit px-3 text-base font-medium"
                    href={dashboardPath}
                  >
                    Dashboard
                  </a>
                  <a
                    onClick={() => signOut(dispatch, 'MANUAL')}
                    className="inline-flex items-center justify-center text-pos-black no-underline text-center
                      h-[35px] w-fit text-base font-medium hover:bg-pos-black hover:text-pos-yellow px-3 rounded-md"
                    href={paths.LOGIN_URL_PATH}
                  >
                    Logout
                  </a>
                </>
              ) : (
                <>
                  <a
                    className="inline-flex items-center justify-center text-pos-black no-underline text-center
                      h-[35px] w-fit text-base font-medium hover:bg-pos-black hover:text-pos-yellow px-3 rounded-md"
                    href={paths.LOGIN_URL_PATH}
                  >
                    Login
                  </a>
                  <a
                    className="hidden tablet:inline-flex items-center justify-center text-pos-black border-2 border-pos-black rounded-md no-underline
                    hover:bg-pos-black hover:text-pos-yellow text-center h-[40px] w-fit px-3 text-base font-medium"
                    href={paths.REGISTER_URL_PATH}
                  >
                    Start free trial
                  </a>
                </>
              )}
            </div>
          </div>
        </header>

        <div className="w-full laptop:w-[60%] mx-auto pt-16 tablet:pt-24 pb-10">
          <div className="flex justify-center flex-col">
            <h1
              className="text-3xl tablet:text-6xl text-pos-black font-bold 
                !leading-normal tablet:!leading-[1.3] text-center"
            >
              Support
            </h1>

            <p className="mt-5 tablet:mt-8 text-[#8f7319] leading-normal text-lg tablet:text-lg text-center">
              We are here to help. Call +233 54 996 1446
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
